import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useMemo } from "react";

const PrivateRoute = ({ children }) => {
  const { token, loading: authLoading } = useSelector((state) => state.auth);
  const { user, loading: profileLoading } = useSelector((state) => state.profile);

  const isLoading = useMemo(
    () => authLoading || profileLoading,
    [authLoading, profileLoading]
  );

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white text-black">
        <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-t-transparent"></div>
        <span className="ml-4 text-xl">Loading...</span>
      </div>
    );
  }

  // ✅ Authenticated
  if (token && user) {
    return children;
  }

  // ✅ Not authenticated → login
  return <Navigate to="/login" replace />;
};

export default PrivateRoute;
